import React, { useState } from "react";

import { Grid, IconButton } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { Location } from "../../../../../../../../models/location";
import FieldView from "../../FieldView";
import { Container, Header, Title, Content, Spacer, Divider } from "./styles";
import { Types, upCaseFirstLetter } from "./types";

type DespatchViewDetailsAddressInfoProps = {
  title: string;
  locations?: Array<Location>;
};

export const DespatchViewDetailsAddressInfos: React.FC<DespatchViewDetailsAddressInfoProps> = (
  props
) => {
  const { title, locations } = props;
  const { t: translate } = useTranslation();

  const [isHidden, setIsHidden] = useState<boolean>(false);

  const renderLocations = () => {
    if (!locations || !locations.length) return null;

    const locationsData = locations;

    return locationsData.map((location, index) => {
      if (!location) return null;

      return (
        <React.Fragment key={location?.id || index}>
          <Content
            item
            container
            direction="row"
            spacing={3}
            data-cy={Types.getDataCY(Types.DataCy.CONTENT, title)}
          >
            <Grid item xs={12}>
              <FieldView
                label={translate("name")}
                value={location?.name}
                data-cy={Types.getDataCY(Types.DataCy.CONTENT_NAME, title)}
              />
            </Grid>
            <Grid item xs={12}>
              <FieldView
                label={translate("address1")}
                value={location?.addressLine1}
                data-cy={Types.getDataCY(Types.DataCy.CONTENT_ADDRESS1, title)}
              />
            </Grid>
            <Grid item xs={3}>
              <FieldView
                label={translate("state")}
                value={location?.state}
                data-cy={Types.getDataCY(Types.DataCy.CONTENT_STATE, title)}
              />
            </Grid>
            <Grid item xs={3}>
              <FieldView
                label={translate("suburb")}
                value={location?.suburb}
                data-cy={Types.getDataCY(Types.DataCy.CONTENT_SUBURB, title)}
              />
            </Grid>
            <Grid item xs={3}>
              <FieldView
                label={translate("country")}
                value={location?.country}
                data-cy={Types.getDataCY(Types.DataCy.CONTENT_COUNTRY, title)}
              />
            </Grid>
            <Grid item xs={3}>
              <FieldView
                label={translate("postCode")}
                value={location?.postalcode}
                data-cy={Types.getDataCY(Types.DataCy.CONTENT_POSTCODE, title)}
              />
            </Grid>
            <Grid item xs={12}>
              <FieldView
                label={translate("address2")}
                value={location?.addressLine2}
                data-cy={Types.getDataCY(Types.DataCy.CONTENT_ADDRESS2, title)}
              />
            </Grid>
          </Content>
          {index + 1 !== locationsData.length && <Divider />}
        </React.Fragment>
      );
    });
  };

  return (
    <Container
      item
      container
      direction="column"
      data-cy={Types.getDataCY(Types.DataCy.CONTAINER, title)}
    >
      <Header
        item
        container
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        data-cy={Types.getDataCY(Types.DataCy.HEADER, title)}
      >
        <Title data-cy={Types.getDataCY(Types.DataCy.TITLE, title)}>
          {upCaseFirstLetter(title)}
        </Title>
        <IconButton
          onClick={() => setIsHidden((prev) => !prev)}
          data-cy={Types.getDataCY(Types.DataCy.TOGGLE, title)}
        >
          {isHidden ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        </IconButton>
      </Header>
      {!isHidden && locations?.length && <Spacer />}
      {!isHidden && renderLocations()}
    </Container>
  );
};
